/** @format */

const template = `
<div class="row">
  <div class="col-12">
    <div class="form-group-mimic">
      <h4 translate>STUDENT_APPLICATIONS.EXTENSION_APPLICATION.APPLIED_EXTENSION_PERIOD</h4>
      <span>
        {{$ctrl.application.requestedTerms}} {{'PROFILE.EXTENSIONS.' + ($ctrl.application.requestedTerms === 1 ? 'SEMESTER' : 'SEMESTERS') |
        translate}}
      </span>
    </div>
  </div>
  <div class="col-6">
    <div class="form-group-mimic">
      <h4 translate>STUDENT_APPLICATIONS.EXTENSION_APPLICATION.DELAY_RATIONALE</h4>
      <span class="text-area-static">{{$ctrl.application.delayRationale}}</span>
    </div>
  </div>
  <div class="col-6">
    <div class="form-group-mimic">
      <h4 translate>STUDENT_APPLICATIONS.EXTENSION_APPLICATION.APPLICATION_RATIONALE</h4>
      <span class="text-area-static">{{$ctrl.application.applicationRationale}}</span>
    </div>
  </div>
</div>
`;
export default template;
